import SuccessSnackBar from './SuccessSnackBar';

export default SuccessSnackBar;
